import script from "./device-command.vue?vue&type=script&lang=ts&setup=true"
export * from "./device-command.vue?vue&type=script&lang=ts&setup=true"

import "./device-command.vue?vue&type=style&index=0&id=2a14c01e&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a14c01e"]])

export default __exports__